import {
  FormLabel
} from "@chakra-ui/react"

const Documentos = () => {

  return (
    <section>
      <FormLabel>Documentos</FormLabel>      
    </section>
  )
}

export default Documentos;
